import classNames from 'classnames';
import React from 'react';
import './LinkButton.less';

export interface ILinkButtonProps extends React.ComponentProps<'button'> {
  color?: 'primary' | 'accent';
}

/**
 * @deprecated use components/Button instead
 */
export function LinkButton({ color, className, ...otherProps }: ILinkButtonProps) {
  return (
    <button
      className={classNames('dpc-link-button', className, {
        'dpc-link-button--primary': color === 'primary',
        'dpc-link-button--accent': color === 'accent',
      })}
      {...otherProps}
    ></button>
  );
}
